import { render, staticRenderFns } from "./RevenueReportTable.vue?vue&type=template&id=2ed85d76&scoped=true&"
import script from "./RevenueReportTable.vue?vue&type=script&lang=js&"
export * from "./RevenueReportTable.vue?vue&type=script&lang=js&"
import style0 from "./RevenueReportTable.vue?vue&type=style&index=0&id=2ed85d76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed85d76",
  null
  
)

export default component.exports